/***
 *
 *   APP LAYOUT
 *   Main application layout containing the navigation
 *   and header (title, secondary nav and signed in user)
 *
 *   PROPS
 *   title: title of the view
 *
 **********/

import React, { Fragment, useEffect } from 'react';
import { Header, User } from 'components/lib';
import { useLocation } from 'react-router-dom';
import { clearEmailSenderPaginationIfAway } from 'utils/emailSenderPagination';
import Style from './app.module.scss';

export function AppLayout(props) {
  // context & style
  const location = useLocation();

  useEffect(() => {
    clearEmailSenderPaginationIfAway(location.pathname);
  }, [location.pathname]);
  return (
    <Fragment>
      <main className={Style.app}>
        <Header title={props.title}>
          <User />
        </Header>

        {<props.children {...props.data} />}
      </main>
    </Fragment>
  );
}
